import { render, staticRenderFns } from "./ModalRegister.vue?vue&type=template&id=a390064c"
import script from "./ModalRegister.vue?vue&type=script&lang=js"
export * from "./ModalRegister.vue?vue&type=script&lang=js"
import style0 from "./ModalRegister.vue?vue&type=style&index=0&id=a390064c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports